import { Box, Button, Paper, Typography } from '@mui/material'
import React from 'react'
import DataTable from '../../components/tables/DataTable'
import PaddingBoxInDesktop from '../../components/layouts/PaddingBoxInDesktop'
import SubmitButton from '../../components/button/SubmitButton'

const VideoSummaryUi = ({ columns, list, filters, setFilters, loading, onExportBtnClick, exportLoading }) => {
    return (
        <>
            <Box mt={3}>
                <Paper elevation={2} sx={{ width: "100%" }}>

                    <Box p={3} pb={0} sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                        <Box>
                            <Typography variant="h6" color={"#000"}>
                                Video Summary
                            </Typography>
                        </Box>

                        {/* <PaddingBoxInDesktop sx={{ display: "flex", flex: 1 }}  > */}
                        <Box sx={{ display: "flex", flexWrap: "wrap" }}  >
                            <SubmitButton loading={exportLoading} variant="contained" onClick={onExportBtnClick} title={"Export CSV"} />
                        </Box>
                        {/* </PaddingBoxInDesktop> */}
                    </Box>

                    <Box p={3} mt={2} height={((list?.length === 0) || loading) ? "55vh" : "80vh"} overflow={"auto"}>
                        <DataTable sticky={true} noPagination={true} columns={columns} rows={list ? list : []} count={list?.length ?? 0} filters={filters} setFilters={setFilters} loading={loading} />
                    </Box>
                </Paper>
            </Box>
        </>)
}

export default VideoSummaryUi